import React from "react";
import "./styles.css";

function About() {
    return(
        <section className="about" id="about">
        <div className="about-img">
        <img className="img2" src={require('./AboutSect.jpg')} alt="Programming" />
        </div>
        <div className="about-content">
            <h2>About <span>Me</span></h2>
            <p>I believe in hard work with direction. Combining my experience 
                as a <span>Website Developer and CSR</span>, I bring intensity and persistence 
                to high-pressure roles to build a career in a dynamic organization 
                where growth is limitless. I aim to apply my technical skills and 
                academic knowledge to serve my duties and convert my potential into 
                kinetic results. I seek an environment that allows me to evolve, 
                evaluate, and enhance my <span>MERN and Python</span> expertise while developing 
                new skills for the future.</p>
             {/* <a href="#home" className="btn">Read More</a> */}
        </div>
        </section>
    )
}

export default About; 